'use client'

import Image from 'next/image'
import { type FC } from 'react'
import { useIntl } from 'react-intl'

import { useCdnMediaServer } from '../../../../cdn'
import { type StoryblokBrandLogoType } from '../../../storyblok'

export const StoryblokBrandProductSearchBrandLogo: FC<{
  brandLogoRootBlock: StoryblokBrandLogoType[] | undefined
  title?: string
}> = ({ brandLogoRootBlock, title }) => {
  const intl = useIntl()

  const { setMediaServerOrigin } = useCdnMediaServer()

  const brandLogo = brandLogoRootBlock?.at(0)?.legacyImageSrc

  if (!brandLogo) {
    return null
  }

  return (
    // eslint-disable-next-line tailwindcss/no-arbitrary-value -- don't reference, refactor if touched
    <div className="relative flex h-[150px] w-full max-w-[280px] items-center justify-center">
      <Image
        alt={intl.formatMessage(
          {
            id: 'brandPage.logo.altText',
          },
          { brandName: title ?? '' },
        )}
        className="object-contain"
        fill
        loading="lazy"
        src={setMediaServerOrigin(`brand-logos/${brandLogo}`)}
        unoptimized
      />
    </div>
  )
}
